export enum EmployeeListingType {
  None = 'Databrydge\\Synchronizer\\Domain\\Connection\\UnlistedEmployeeDto',
  Whitelist = 'Databrydge\\Synchronizer\\Domain\\Connection\\WhitelistedEmployeeDto',
  Blacklist = 'Databrydge\\Synchronizer\\Domain\\Connection\\BlacklistedEmployeeDto',
}
